import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue';
import { Dialog, Popover } from 'element-ui';
import MenuTabsScrollable from 'library-@/components/MenuTabs/MenuTabsScrollable';
import CompareLoadingContent from './CompareTextContent.vue';
import { useCompareInit } from '@/composables/use-compare-init';
import { useCompareUrlState } from '@/composables/use-compare-url-state';
import { useI18n } from '@/composables/use-i18n';
import { useRoute } from 'vue-router/composables';
import { usePatentBasic } from '@/composables/use-patent-basic';

import _ from 'lodash';

interface Patent {
    PN?: string;
    Origin_TITLE?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CompareText',
  setup(__props) {

const ElDialog = Dialog;
const ElPopover = Popover;

const { t } = useI18n();
const route = useRoute();
const { leftId, rightId } = useCompareUrlState();
const { textCompareLang } = useCompareInit();
const { getPatentBase } = usePatentBasic();

const showDialog = ref(false);

// 假的tab
const tabsLabel = {
    clms: t('patent-view.CLMS'),
    desc: t('patent-view.DESC'),
};

const hasTextCompareLangTab = computed(() => {
    return _.pickBy(textCompareLang.value, item => item);
});

const defaultTabs = computed(() => {
    const tabList = Object.keys(hasTextCompareLangTab.value || {}).sort();
    return tabList.map(item => {
        return {
            label: tabsLabel[item],
            key: item,
            hasAcl: true,
        };
    });
});

const currentTab = ref('');

const setDefaultTab = () => {
    const curTab = route.params.left;
    if (_.get(hasTextCompareLangTab.value, curTab)) {
        currentTab.value = curTab;
    } else {
        currentTab.value = _.get(defaultTabs.value[0], 'key', 'clms');
    }
};

const compareAddedLoaded = ref(false);
const compareRemoveLoaded = ref(false);

const isCompareTextLoaded = computed(() => {
    return compareAddedLoaded.value && compareRemoveLoaded.value;
});

const switchTabHandler = (item) => {
    if (!isCompareTextLoaded.value) return;
    currentTab.value = item.key;
};

const leftPatent = ref<Patent>({});
const rightPatent = ref<Patent>({});
const comparePatentTextInit = async () => {
    Promise.all([getPatentBase(leftId.value), getPatentBase(rightId.value)])
        .then(([left, right]) => {
            leftPatent.value = left;
            rightPatent.value = right;
        });
};
const onShowComparePatentText = async () => {
    setDefaultTab();
    showDialog.value = true;
    await comparePatentTextInit();
};

const compareBtnDisabled = computed(() => {
    return !textCompareLang.value || _.isEmpty(hasTextCompareLangTab.value);
});


return { __sfc: true,ElDialog, ElPopover, t, route, leftId, rightId, textCompareLang, getPatentBase, showDialog, tabsLabel, hasTextCompareLangTab, defaultTabs, currentTab, setDefaultTab, compareAddedLoaded, compareRemoveLoaded, isCompareTextLoaded, switchTabHandler, leftPatent, rightPatent, comparePatentTextInit, onShowComparePatentText, compareBtnDisabled, MenuTabsScrollable, CompareLoadingContent }
}

})